module.exports = __webpack_public_path__ + "img/edit_grid.353ba99c.png";